import { Grid, GridColumn, GridRow, ImportantIcon, Switch } from '@bp/ui-components';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useTimetableStore } from '../TimetableProvider';
import styles from './GenerateForm.module.scss';

export const GenerateForm = observer(() => {
  const { t } = useTranslation();

  const pinboardStore = useTimetableStore();

  return (
    <div className={styles['generate-form']}>
      <Grid>
        <GridRow headline={t('mathplan.disclaimer')}>
          <GridColumn width={6}>
            <div className='mb-7'>{t('pinboard.generate.selected')}</div>
            <div>
              {pinboardStore.selectedRows.length > 0 && pinboardStore.context === 'classes'
                ? pinboardStore.selectedRows.map((row) => row.label).join(', ')
                : t('pinboard.generate.all')}
            </div>
          </GridColumn>
          <GridColumn width={6}>
            <GridRow>
              <div>{t('pinboard.generate.options')}</div>
            </GridRow>
            <GridRow spacingBottom={'s'}>
              <Switch
                label={t('pinboard.generate.keepCards')}
                direction='right'
                name='cards'
                checked={pinboardStore.generatorOptions.keepExistingPositions}
                onChange={() =>
                  pinboardStore.setKeepExistingPositions(!pinboardStore.generatorOptions.keepExistingPositions)
                }
              />
            </GridRow>
            <GridRow spacingBottom={'s'} spacingTop={'s'}>
              <Switch
                label={t('pinboard.generate.withRooms')}
                direction='right'
                name='rooms'
                checked={pinboardStore.generatorOptions.includeRoomResources}
                onChange={() =>
                  pinboardStore.setIncludeRoomResources(!pinboardStore.generatorOptions.includeRoomResources)
                }
              />
            </GridRow>
            <GridRow spacingTop={'s'}>
              <Switch
                label={t('pinboard.generate.considerTeachingBlock')}
                direction='right'
                name='teachingBlock'
                checked={pinboardStore.generatorOptions.includeSubjectContainer}
                onChange={() =>
                  pinboardStore.setIncludeSubjectContainer(!pinboardStore.generatorOptions.includeSubjectContainer)
                }
              />
            </GridRow>
          </GridColumn>
        </GridRow>
        {!pinboardStore.generatorOptions.keepExistingPositions && (
          <GridRow spacingBottom={pinboardStore.generatorOptions.includeSubjectContainer ? 'none' : 's'}>
            <div className={styles.warning}>
              <ImportantIcon className={styles.icon} />
              <div>{t('pinboard.generate.deleteHint')}</div>
            </div>
          </GridRow>
        )}
        {pinboardStore.generatorOptions.includeSubjectContainer && (
          <GridRow>
            <div className={styles.info}>
              <ImportantIcon className={styles.icon} />
              <div>{t('pinboard.generate.subjectContainerHint')}</div>
            </div>
          </GridRow>
        )}
      </Grid>
    </div>
  );
});
